import { CSSObject } from "@emotion/react";
import { type ButtonStyleOverrides, constants } from "@newsela/angelou";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const homeMenuSubItemPopoutContainerCss: CSSObject = {
  display: "flex",
  maxHeight: "500px",
  overflowY: "scroll",
  flexDirection: "column",
  padding: "1rem 0 1.25rem 0",
  background: constants.colors.ui.white[50],
  borderRadius: "0.5rem",
  gap: "1rem",
  boxShadow: "0px 2px 6px 0px rgba(29, 29, 29, 0.16)",
};

export const backToMenuAnchorCss: ButtonStyleOverrides<CSSObject> = {
  root: {
    textDecoration: "none",
    padding: "0 1rem",
    color: constants.colors.ui.core[700],
    display: "flex",
    flexDirection: "row",
    gap: "0.25rem",

    [`@media (min-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
      display: "none",
    },
  },
};

export const backToMenuIconCss = {
  root: {
    width: "1rem",
    height: "1rem",

    path: {
      strokeWidth: "0.25rem",
      stroke: constants.colors.ui.core[700],
    },
  },
};
